(() => {
  function initGallery(section) {
    const chips = section.querySelectorAll('.hc-chip');
    const tiles = Array.from(section.querySelectorAll('.hc-gallery-tile'));
    const empty = section.querySelector('[data-hc-empty]');
    const resetBtn = section.querySelector('[data-hc-reset]');
    const moreBtn = section.querySelector('[data-hc-more]');
    const moreWrap = section.querySelector('[data-hc-more-wrap]');

    const INITIAL = parseInt(section.dataset.initial, 10) || 4;
    const STEP = parseInt(section.dataset.step, 10) || 4;

    let filtered = tiles.slice();
    let shown = 0;

    function applyVisible(newShown, animateFrom) {
      // Tiles not in current filtered set
      tiles.filter(t => !filtered.includes(t)).forEach(t => {
        t.removeAttribute('data-animate-in');
        t.setAttribute('data-hidden', '');
      });

      // Tiles in filtered set
      filtered.forEach((t, i) => {
        if (i < newShown) {
          const wasHidden = t.hasAttribute('data-hidden');
          t.removeAttribute('data-hidden');
          if (wasHidden && i >= animateFrom) {
            t.removeAttribute('data-animate-in');
            void t.offsetWidth;
            t.style.animationDelay = `${(i - animateFrom) * 40}ms`;
            t.setAttribute('data-animate-in', '');
            t.addEventListener('animationend', () => {
              t.removeAttribute('data-animate-in');
              t.style.animationDelay = '';
            }, { once: true });
          }
        } else {
          t.removeAttribute('data-animate-in');
          t.setAttribute('data-hidden', '');
        }
      });

      shown = newShown;

      if (moreWrap) moreWrap.hidden = shown >= filtered.length;
      if (empty) empty.hidden = filtered.length > 0;
    }

    function filter(cat) {
      chips.forEach(chip => {
        chip.classList.toggle('hc-chip--active', chip.dataset.cat === cat);
      });

      filtered = cat === 'All'
        ? tiles.slice()
        : tiles.filter(t => t.dataset.category === cat);

      shown = 0;
      applyVisible(Math.min(INITIAL, filtered.length), 0);
    }

    // Init — no animation on first load
    tiles.forEach(t => t.setAttribute('data-hidden', ''));
    applyVisible(Math.min(INITIAL, tiles.length), tiles.length);

    chips.forEach(chip => {
      chip.addEventListener('click', () => filter(chip.dataset.cat));
    });

    resetBtn?.addEventListener('click', () => filter('All'));

    moreBtn?.addEventListener('click', () => {
      const prev = shown;
      applyVisible(Math.min(shown + STEP, filtered.length), prev);
    });

    section.addEventListener('shopify:section:unload', () => {});
  }

  document.querySelectorAll('.hc-gallery-browse').forEach(initGallery);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.hc-gallery-browse');
    if (section) initGallery(section);
  });
})();
